import * as React from "react";

import { Link as RouterLink, Redirect, useHistory } from "react-router-dom";

import firebase from "firebase/app";

import { Box, Button, Grid, Link, TextField, Typography } from "@material-ui/core";

import { Page } from "../Page";
import { IPageProps } from "../IPageProps";

import { ForgotPasswordRoute, HomeRoute, SignUpRoute } from "Routes";

export function LoginPage(props: IPageProps): React.ReactElement {
    const history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");

    const [error, setError] = React.useState("");

    if (props.user !== undefined) {
        return <Redirect to={HomeRoute.path} />;
    }

    const handleEmailChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const handlePasswordChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const onClick = async () => {
        setLoading(true);

        try {
            const credentials = await firebase.auth().signInWithEmailAndPassword(email, password);
            const user = credentials.user;

            if (user === null) {
                setError("Login did not produce a valid user.");
                return;
            }
            
            if (user.emailVerified) {
                history.push(HomeRoute.path);
                return;
            } else {
                await user.sendEmailVerification();
                await firebase.auth().signOut();

                setError("Your e-mail address has not been verified. Please check your e-mail and follow the link in it to verify your e-mail.")
            }
        } catch (error) {
            const e = error as Error;

            setError(e.message);
        }

        setLoading(false);
    };

    return (
        <Page>
            <Box mb={2}>
                <Typography variant="h5">Login</Typography>
            </Box>

            <Grid container direction="column" alignItems="center" spacing={3}>
                <Grid item>
                    <TextField fullWidth value={email} onChange={handleEmailChanged} disabled={loading} label="Email" type="email" autoComplete="email"/>
                </Grid>
                <Grid item>
                    <TextField fullWidth value={password} onChange={handlePasswordChanged} disabled={loading} label="Password" type="password" autoComplete="current-password"/>
                </Grid>
                <Grid item>
                    <Button onClick={onClick} disabled={loading} variant="contained" color="primary">Login</Button>
                </Grid>
                {error.length !== 0 &&
                    <Grid item>
                        <Typography color="error">{error}</Typography>
                    </Grid>
                }
                <Grid item>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography>Don't have an account? <Link component={RouterLink} to={SignUpRoute.path}>Sign up!</Link></Typography>
                        <Typography>If you create an account you can save quilts you like and download them as wallpaper!</Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Typography><Link component={RouterLink} to={ForgotPasswordRoute.path}>I forgot my password!</Link></Typography>
                </Grid>
            </Grid>
        </Page>
    );
}